<template>
  <div>
    <vue-page-transition name="fade">
      <div class="splash" v-if="!splashShown">
        <div class="container">
          <div class="row">
            <div class="col col-md-8 offset-md-2 text-center col-splash">
              <div>
                <video class="icon-animation" preload="auto" autoplay playsinline muted>
                  <source src="/static/video/icon-animation.mp4" type="video/mp4">
                </video>
              </div>
              <div>
                <vue-page-transition name="fade">
                  <h1 class="h1-xxl" v-if="iconShown">Hello</h1>
                </vue-page-transition>
                <vue-page-transition name="fade">
                  <h1 class="h1-xl lh1" v-if="helloShown">we are <span class="text-primary">resolute</span></h1>
                </vue-page-transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vue-page-transition>
    <div class="container">
      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <hr class="space space-sm d-none d-sm-block">
          <h1 class="title h1-xl py-4">Dreamers &amp; <span class="text-primary">Doers</span></h1>
          <p class="largest py-4">
            We are independent creators and engineers, artists and scientists, who often join forces to work on innovative projects.
          </p>
          <p>
            We are thinkers, creatives, designers and hackers. We wear many hats, we learn new things and we focus on the task at hand.
            We've been there and done that. We know how it feels.
          </p>
          <p>
            <span class="regular text-primary">resolute</span> is the platform that brings us together and helps to find interesting
            projects to work on. You can join us, as a member or as a client (or both - we're not into labels):
          </p>

          <hr class="space space-sm d-none d-sm-block">
          <router-link class="btn btn-primary" :to="{ name: 'request-proposal' }">Get in touch</router-link>
          <router-link class="btn btn-outline-primary" :to="{ name: 'services' }">What we do</router-link>
          <hr class="space space-lg">
        </div>
      </div>
      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <h1 class="title py-4">Where great ideas meet<br class="d-none d-md-block"> <span class="text-primary">brilliant execution</span></h1>
          <p class="larger py-4">
            We focus on creating exceptional digital products.
          </p>
          <p v-view="onVideoInView">
            <video ref="animation" class="img-fluid" preload="auto" playsinline muted>
              <source src="/static/video/about-animation.mp4" type="video/mp4">
            </video>
          </p>
          <p>
            It takes passion and perseverance to produce high quality work.<br>
            It also takes a lot of time. This means we can only
            take some projects and have to turn down others. 
          </p>
          <p>
            We may miss some great opportunities this way, but we'll have a lot of joy working
            on those we pick, producing the kind of work we love.
          </p>
          <p>
             That's what we enjoy the most.
          </p>
          <hr class="space space-lg">
        </div>
      </div>
      <div class="row" v-if="clients && clients.length > 0">
        <div class="col text-center">
          <p class="text-center">
            We've worked with some great people along the way.
          </p>
          <hr class="space space-sm">
          <div class="row clients">
            <div class="col-3 col-md mb-4 text-center pr-1" v-for="(client, index) in clients" :key="index">
              <img class="img-fluid" :src="client.logo" :alt="client.name">
            </div>
          </div>
          <hr class="space space-lg">
        </div>
      </div>
      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <p>
            We are also quite nice people. Or so they say.
          </p>
          <hr class="space space-xs">
          <router-link class="btn btn-primary" :to="{ name: 'request-proposal' }">Get in touch</router-link>
          <router-link class="btn btn-outline-primary" :to="{ name: 'home' }">Recent work</router-link>
        </div>
      </div>
      <hr class="space">
    </div>
    <hr class="space">
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'about',
  data () {
    return {
      splashShown: window.splashShown || false,
      iconShown: false,
      helloShown: false,
      videoPlayed: false
    }
  },
  computed: {
    ...mapState({
      clients: state => state.clients.clients
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    setTimeout(() => { this.iconShown = true }, 1500)
    setTimeout(() => { this.helloShown = true }, 2500)
    setTimeout(() => { this.splashShown = true; window.splashShown = true }, 4000)
  },
  created () {
    this.$store.dispatch('LOAD_CLIENTS')
  },
  methods: {
    onVideoInView (e) {
      if (e.type === 'enter' || (e.type === 'progress' && !this.videoPlayed)) {
        this.videoPlayed = true
        this.$refs.animation.play()
      }
    }
  }
}
</script>
